import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
  Form as F,
  Modal,
  Spinner
} from "react-bootstrap";
// import { Form } from "antd";
import moment from "moment";
import Datetime, { format } from "react-datetime";
import "react-datetime/css/react-datetime.css";
import ConsultasAPI from "../../../shared/helpers/consultasAPI";
// import TablasExtractos from "./TablasExtractos";
import { Link } from "react-router-dom";
import { FcCalendar } from "react-icons/fc";
import "bootstrap/dist/css/bootstrap.min.css";
// import { Navigate } from 'react-router-dom';
// const FormItem = Form.Item;

const BuscarTuqui = () => {
  // const URL_EXTRACTOREGISTRO = window.API_ROUTES.EXTRACTOREGISTRO;
  // const URL_TIPOSORTEO = window.API_ROUTES.TIPOSORTEO;
  // const URL_EXTRACTO = window.API_ROUTES.EXTRACTOS;
  const URL_PUBLICACION = window.API_ROUTES.PUBLICACION_EXTRACTO;

  // const [form] = Form.useForm();
  const [fecha, setFecha] = useState({
    fechaMuestra: moment().format("MM/YYYY"),
    fechaComparar: moment().format("YYYY-MM"),
  });

  const [isLoading, setIsLoading] = useState(false);
  const [listaImagenes, setListaImagenes] = useState([]);
  const fechaActual = moment();
  const [mesSeleccionado, setMesSeleccionado] = useState(
    fechaActual.format("MMMM").charAt(0).toUpperCase() +
    fechaActual.format("MMMM").slice(1).toLowerCase()
  );
  const [añoSeleccionado, setAñoSeleccionado] = useState(fechaActual.format("YYYY"));
  const datetimeRef = useRef(null);

  const handleClick = (id) => {
    const nuevasImagenes = listaImagenes.map(extracto => extracto.id === id ? { ...extracto, estadoI: !extracto.estadoI } : extracto); // crea una copia de listaImagenes
    setListaImagenes(nuevasImagenes);
  };


  useEffect(() => {
    llamarImagen();
  }, [fecha]);

  const llamarImagen = async () => {
    try {
      setIsLoading(true);
      const fecha_vector = fecha.fechaComparar.split('-')
      const response = await ConsultasAPI.ObtenerObjeto(URL_PUBLICACION, fecha_vector[1] + '/' + fecha_vector[0]);
      const opciones = [];
      if (response.status === 200) {
        response.data.forEach(extracto => {
          let s = {
            id: extracto.id,
            img_file: extracto.img_file ? extracto.img_file : '',
            fecha_c: extracto.fecha_sorteo,
            estadoI: false,
            sorteo: extracto.sorteo,
          };
          opciones.push(s);
        });
        setListaImagenes(opciones);
        setIsLoading(false);
      } else {
        setListaImagenes([]);
        setIsLoading(false);
      }
    } catch (error) {
      setListaImagenes([]);
      setIsLoading(false);
      console.error("Error al cargar imágenes:", error);
    }
  }

  const handleIconClick = () => {
    datetimeRef.current._openCalendar(); // Abrir el calendario al hacer clic en el icono
  };

  return (
    <div className="mainSection my-4">
      <Row className="d-flex justify-content-center row-cols-2" >
        <Col md={9} sm={12} xs={12} className="justify-content-center">
          <Row className="d-flex flex-column align-items-center justify-content-center" >
            <Col md={6} className="d-flex flex-column align-items-center justify-content-center" >
              <Row >
                <F.Label className="letraCaja text-center" style={{ fontSize: '150%', padding: '15px' }}>
                  Resultados del Tuqui 10 de Tucumán - {mesSeleccionado} {añoSeleccionado}
                </F.Label>
              </Row>
              <F.Label className="letraCaja">Ver resultados de:</F.Label>
              <F.Group style={{ display: "flex", alignItems: "center", paddingBottom: '16px', paddingTop: "4px" }}>
                <FcCalendar size={50} onClick={handleIconClick} style={{ cursor: "pointer" }} />
                <Datetime
                  ref={datetimeRef}
                  className="custom-datetime"
                  timeFormat={false}
                  dateFormat="MM/YYYY"
                  inputProps={{
                    readOnly: true,
                    placeholder: "Buscar",
                  }}
                  value={fecha.fechaMuestra}
                  onChange={(momentDate) => {
                    const fechaMuestra = momentDate.format("MM/YYYY");
                    const fechaComparar = momentDate.format("YYYY-MM");
                    const nuevoAñoSeleccionado = momentDate.format("YYYY");
                    const nuevoMesSeleccionado =
                      momentDate.format("MMMM").charAt(0).toUpperCase() +
                      momentDate.format("MMMM").slice(1).toLowerCase();
                    setFecha({
                      fechaMuestra: fechaMuestra,
                      fechaComparar: fechaComparar,
                    });
                    setMesSeleccionado(nuevoMesSeleccionado);
                    setAñoSeleccionado(nuevoAñoSeleccionado);
                  }}
                  closeOnSelect={true}
                />
              </F.Group>
              {listaImagenes.length > 0 ? (
                listaImagenes.map((imagen) => (
                  <F.Group key={imagen.id} style={{ width: "100%", padding: '10px' }}>
                    <button
                      className="collapsed botonCPA justify-content-center"
                      style={{ width: "100%", backgroundColor: '#cfd8dc', color: 'black', borderColor: '#cfd8dc' }}
                      onClick={() => handleClick(imagen.id)}
                    >
                      <Col>
                        <h5 style={{ padding: '9px' }}>Sorteo N°{imagen.sorteo} - Fecha {imagen.fecha_c} </h5>
                        <h6>Haga Click Aqui</h6>
                      </Col>

                    </button>
                    {imagen.estadoI ? (
                      <Col className="imagen-container">
                        <img
                          src={imagen.img_file}
                          className="imagen my-2"
                          style={{ width: "100%" }}
                          alt={`Imagen ${imagen.id}`}
                        />
                      </Col>
                    ) : null}
                  </F.Group>
                ))
              ) : (
                <Row className="row-tabla p-3">
                  <h3 className="letraCaja" style={{ fontSize: "150%", textAlign: 'center' }}>
                    No se realizaron sorteos en el mes seleccionado
                  </h3>
                </Row>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
      <Modal centered show={isLoading}>
        <Modal.Body className="text-center">
          <Spinner animation="border" />
          <p>Cargando...</p>
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default BuscarTuqui;